const _ = require('../lodash');

const validate = require('./validatejs/validate.js');
const moment = require('moment-timezone');
const { parsePhoneNumber } = require('libphonenumber-js/core');
const phoneMetadataImport = require('libphonenumber-js/metadata.max.json');
const phoneMetadata = phoneMetadataImport.default || phoneMetadataImport;

validate.validators.object = function () {
   return null;
};

validate.validators.string = function () {
   return null;
};

validate.validators.integer = function () {
   return null;
};

validate.validators.decimal = function () {
   return null;
};

validate.validators.name = function () {
   return null;
};

validate.validators.defaultValue = function () {
   return null;
};
validate.validators.nullable = function () {
   return null;
};
validate.validators.boolean = function (value) {
   if (value == null) {
      return null;
   }
   return _.isBoolean(value) || value.toString() === 'true' || value.toString() === 'false' ? null : 'should be a boolean';
};

validate.validators.long = function (value) {
   if (value == null) {
      return null;
   }

   let valid = true;
   try {
      const bn = BigInt(value);
      valid = bn.toString() === value.toString();
   } catch (e) {
      valid = false;
   }

   return valid ? null : 'should be a bigint';
};

validate.validators.phone = function (value) {
   if (value == null) {
      return null;
   }

   try {
      const phone = parsePhoneNumber(value, phoneMetadata);

      if (!phone || !phone.isValid()) {
         return 'must be a valid international phone number';
      }

      return null;
   } catch (ex) {
      console.log(ex);
      return 'must be a valid international phone number (err)';
   }
};

validate.validators.requiredUnless = function (value, options, key, attributes) {
   const { other } = options;
   const otherValue = attributes[other];

   if ((value == null || value === '') && (otherValue == null || otherValue === '')) {
      return options.message || `${key} is required when ${other} is not provided`;
   }

   return null;
};

validate.validators.func = function (value, options, key, attributes) {
   return options.validator(value, options, key, attributes);
};

//validate.options = {format: "flat"};
validate.extend(validate.validators.datetime, {
   // The value is guaranteed not to be null or undefined but otherwise it
   // could be anything.
   parse: function (value) {
      return +moment.utc(value, true);
   },
   // Input is a unix timestamp
   format: function (value, options) {
      const format = options.dateOnly ? 'YYYY-MM-DD' : 'YYYY-MM-DD hh:mm:ss';
      return moment.utc(value).format(format);
   }
});

module.exports.validate = validate;
//module.exports.types = require('./types');
